import { useEffect } from 'react'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import { useRightPanel } from './rightPanelContext'
import useRightPanelRedesign from './useRightPanelRedesign'

export const sidebarBlockId = (moduleKey: string) => `sidebar-module-${moduleKey}`

const useRightPanelLayout = (country: string) => {
  const { expanded, request } = useRightPanel()
  const redesignEnabled = useRightPanelRedesign()

  useEffect(() => {
    if (!request) return undefined
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(sidebarBlockId(request.key))?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    })
    return () => window.cancelAnimationFrame(frame)
  }, [request])

  return {
    hidden: !redesignEnabled,
    expanded,
    rail: !expanded,
    // @ts-ignore
    ibanVerifierHidden: !modulesConfig[country]?.rightPanel?.ibanVerifier,
  }
}

export default useRightPanelLayout
